// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__1q8mT","spinner":"Loading_spinner__6t13J"};